import { QueryBuilder } from '@cxc/core/builders';
import { withCache } from '@ngneat/cashew';
import { DateTime } from 'luxon';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@environments/environment';

import { platformAPI } from '@services/API/endpoints';

@Injectable({
  providedIn: 'root',
})
export class CoreMetricsApi {
  private http = inject(HttpClient);

  getCoreMetrics(
    trustId: string,
    reported_at: string,
    currency: string,
    loaderOptIn: boolean | string = true
  ) {
    const query = new QueryBuilder();

    const cutoffDate = DateTime.fromFormat(reported_at, 'dd/MM/yyyy').toFormat(
      'yyyy-MM-dd'
    );
    query.equals('reported_at', cutoffDate);
    query.equals('show_cutoff_dates', 'false');
    query.equals('currency', currency);
    const url = `${platformAPI.trusts(trustId).lender.coreMetrics(query)}`;
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Loader-Opt-In': `${loaderOptIn}`,
        'Auth-Opt-In': 'true',
      }),
      context: withCache({
        ttl: environment.CACHE_LIFETIME,
      }),
    });
  }

  /**
   * The lender's cut-off dates, newest first.
   *
   * LEN-2948: this used to be `core-metrics?show_cutoff_dates=true`. Same
   * answer, but that route also serves the Overview's figures, and its
   * permission guards the path rather than the payload — so letting a facility
   * analyst read a date let them flip the flag and read the money too. The
   * dedicated route takes no such flag.
   */
  getCutOffDates(trustId: string, loaderOptIn: boolean | string = true) {
    const query = new QueryBuilder();
    const reportedAt = DateTime.now().toFormat('yyyy-MM-dd');
    query.equals('reported_at', reportedAt);
    const url = `${platformAPI.trusts(trustId).lender.cutOffDates(query)}`;
    return this.http.get<string[]>(url, {
      headers: new HttpHeaders({
        'Loader-Opt-In': `${loaderOptIn}`,
        'Auth-Opt-In': 'true',
      }),
      context: withCache({
        ttl: environment.CACHE_LIFETIME,
      }),
    });
  }
}
